// PGCET MCA Mock 4 — General English (questions 91–100)
const pgcetmcaGeneralEnglish = [
  {
    id: 91,
    question: "Choose the word nearest in meaning to PERSPICACIOUS.",
    options: ["A. Perspiring", "B. Discerning", "C. Obstinate", "D. Transparent"],
    answer: "B"
  },
  {
    id: 92,
    question: "Choose the antonym of LACONIC.",
    options: ["A. Concise", "B. Terse", "C. Verbose", "D. Pithy"],
    answer: "C"
  },
  {
    id: 93,
    question: "Choose the correct meaning of the phrase \"a Pyrrhic victory\".",
    options: [
      "A. A victory won at such great cost that it is hardly worth winning",
      "B. An easy and unexpected victory",
      "C. A victory celebrated with a bonfire",
      "D. A victory decided by a very narrow margin"
    ],
    answer: "A"
  },
  {
    id: 94,
    question: "Choose the one word for: government by the wealthy.",
    options: ["A. Aristocracy", "B. Oligarchy", "C. Theocracy", "D. Plutocracy"],
    answer: "D"
  },
  {
    id: 95,
    question: "Find the part of the sentence that contains an error: Hardly had he reached the station (A) / when the train had left (B) / for Mumbai (C) / No error (D)",
    options: ["A. Hardly had he reached the station", "B. when the train had left", "C. for Mumbai", "D. No error"],
    answer: "B"
  },
  {
    id: 96,
    question: "Choose the correct passive form of: Who wrote this letter?",
    options: [
      "A. Who was this letter written by him?",
      "B. By whom this letter was written?",
      "C. By whom was this letter written?",
      "D. By whom has this letter been written?"
    ],
    answer: "C"
  },
  {
    id: 97,
    question: "Choose the pair of words that best fills the blanks: The committee's report was so ______ that even experts found it difficult to ______ its central argument.",
    options: ["A. convoluted, discern", "B. lucid, grasp", "C. brief, ignore", "D. convincing, dispute"],
    answer: "A"
  },
  {
    id: 98,
    question: "Choose the correctly spelt word.",
    options: ["A. Accomodate", "B. Acommodate", "C. Acomodate", "D. Accommodate"],
    answer: "D"
  },
  {
    id: 99,
    question: `Arrange the sentences to form a coherent paragraph:
      P: As a result, many firms now invest heavily in cybersecurity.
      Q: Over the last decade, businesses have moved most of their data online.
      R: This shift has made them attractive targets for hackers.
      S: Yet experts warn that technology alone cannot prevent breaches caused by careless employees.`,
    options: ["A. RQPS", "B. QPRS", "C. QRPS", "D. QSRP"],
    answer: "C"
  },
  {
    id: 100,
    question: "Read the passage and answer the question: \"The paradox of automation is that the more efficient an automated system becomes, the more crucial the contribution of its human operators. When automation fails, operators who have rarely needed to intervene may lack both the skills and the situational awareness to respond effectively.\" Which inference is best supported by the passage?",
    options: [
      "A. Automated systems should be abolished",
      "B. Humans are always more reliable than machines",
      "C. Efficient automated systems never fail",
      "D. Heavy reliance on automation can erode the very skills needed when it fails"
    ],
    answer: "D"
  }
];

export default pgcetmcaGeneralEnglish;
